import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // adjust if needed
});

export const checkDonor = (mobile) =>
  API.post("/donors/check", { mobile });

export const createDonor = (data) =>
  API.post("/donors/create", data);

export const createDonation = (data) =>
  API.post("/donations", data);
